import { render, staticRenderFns } from "./OrdenCompraCanceladas.vue?vue&type=template&id=311f29e2&"
import script from "./OrdenCompraCanceladas.vue?vue&type=script&lang=js&"
export * from "./OrdenCompraCanceladas.vue?vue&type=script&lang=js&"
import style0 from "./OrdenCompraCanceladas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports